<template>
  <div class="content">
    <div class="page-inner">
      <h1 class="mb-4">
        {{ $t('forms') }}
      </h1>
      <select v-model="categoryFilter" class="form-control" v-if="beta">
        <option value="">{{ $t('all_categories') }}</option>
        <option value="account verification">{{ $t('account_verification_form') }}</option>
        <option value="apple">{{ $t('apple_double_check_form') }}</option>
        <option value="digital stores content relocation">{{ $t('digital_stores_content_relocation_form') }}</option>
        <option value="facebook">{{ $t('facebook_whitelist_form') }}</option>
        <option value="featuring verification">{{ $t('featuring_verification_form') }}</option>
        <option value="instagram">{{ $t('instagram_linking_form') }}</option>
        <option value="licenses submission form">{{ $t('licenses_submission_forms') }}</option>
        <option value="metadata changes">{{ $t('metadata_changes_form') }}</option>
        <option value="migration to indiefy">{{ $t('migration_to_indiefy_form') }}</option>
        <option value="release data confirmation">{{ $t('release_data_confirmation_form') }}</option>
        <option value="soundcloud merge">{{ $t('soundcloud_merge_form') }}</option>
        <option value="soundcloud whitelist">{{ $t('soundcloud_whitelist_form') }}</option>
        <option value="spotify content relocation">{{ $t('spotify_content_relocation_form') }}</option>
        <option value="takedown">{{ $t('takedown_still_live_form') }}</option>
        <option value="youtube verification">{{ $t('youtube_verification_form') }}</option>
        <option value="youtube whitelist">{{ $t('youtube_whitelist_form') }}</option> -->
      </select>
      <!-- <div class="mt-3 mb-3 text-center">
        <ins class="adsbygoogle"
          style="display:block"
          data-ad-client="ca-pub-8326584585992829"
          data-ad-slot="1178271480"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
      </div> -->
      <div class="row mt-3" v-if="beta">
        <div class="col-md-6" v-for="(service, index) in filteredServices" v-bind:key="`service_${index}`" v-show="!service.admin || (service.admin && user.role === 'admin')">
          <a class="card" v-if="service.price === 'free' || user.subscription" :href="service.url" target="_blank">
            <div class="card-body p-3">
              <div class="row mb-2">
                <div class="col-4">
                  <img :src="service.image" :aylt="service.name" class="img-fluid">
                  <div class="text-muted mt-3 small">
                    Powered by<br/>{{ service.provider }}
                  </div>
                </div>
                <div class="col-8 pos-relative">
                  <div class="mb-4">
                    <div class="h4 mb-1">
                      {{ service.name }}
                    </div>
                    <div class="text-black mb-2" v-html="service.description">
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-price">
                <span v-if="!user.subscription" class="badge">Free</span>
              </div>
            </div>
          </a>
          <router-link v-else  to="/upgrade?from=forms" class="card">
            <div class="card-body p-3">
              <div class="row mb-2">
                <div class="col-4">
                  <img :src="service.image" :aylt="service.name" class="img-fluid">
                  <div class="text-muted mt-3 small">
                    Powered by<br/>{{ service.provider }}
                  </div>
                </div>
                <div class="col-8 pos-relative">
                  <div class="mb-4">
                    <div class="h4 mb-1">
                      {{ service.name }}
                    </div>
                    <div class="text-black mb-2" v-html="service.description">
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-price">
                <span v-if="!user.subscription" class="badge badge-success">PRO Only</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'

export default {
  name: 'Forms',
  data: function () {
    return {
      categoryFilter: '',
      beta: true,
      stripe: {},
      services: [
        {
          name: this.$t('artist_data_confirmation'),
          description: this.$t('account_verification_featuring_release_verification'),
          provider: 'Indiefy',
          category: 'account verification',
          image: '/static/img/forms/account-verification.jpg',
          url: 'https://forms.gle/39NQA8iqp5bznqYH8',
          price: 'free'
        },
        {
          name: this.$t('apple_double_check_form'),
          description: this.$t('apple_double_check'),
          provider: 'Indiefy',
          category: 'apple',
          image: '/static/img/forms/apple-double-check.jpg',
          url: 'https://forms.gle/eyo2edTQKcqFJmjj9',
          price: 'pro'
        },
        {
          name: this.$t('digital_stores_content_relocation_form'),
          description: this.$t('digital_stores_content_relocation'),
          category: 'digital stores content relocation',
          provider: 'Indiefy',
          image: '/static/img/forms/digital-stores-content-relocation.jpg',
          url: 'https://forms.gle/kVeTeHkgHBk9VdrZ7',
          price: 'free'
        },
        {
          name: this.$t('facebook_whitelist_form'),
          description: this.$t('facebook_whitelist'),
          category: 'facebook',
          provider: 'Indiefy',
          image: '/static/img/forms/facebook-whitelist.jpg',
          url: 'https://forms.gle/Z6tG56brWkXLeMB79',
          price: 'pro'
        },
        {
          name: this.$t('featuring_verification_form'),
          category: 'featuring verification',
          provider: 'Indiefy',
          description: this.$t('featuring_verification'),
          image: '/static/img/forms/featuring.jpg',
          url: 'https://forms.gle/4o26Q5AMrB4k4PaG6',
          price: 'free'
        },
        {
          name: this.$t('instagram_linking_form'),
          description: this.$t('instagram_linking'),
          category: 'instagram',
          provider: 'Indiefy',
          image: '/static/img/forms/instagram-linking.jpg',
          url: 'https://forms.gle/xMAN2c5Kf2Pb1pqy8',
          price: 'pro'
        },
        {
          name: this.$t('licenses_submission_forms'),
          description: this.$t('licenses_submission_form'),
          category: 'licenses submission form',
          provider: 'Indiefy',
          image: '/static/img/forms/licenses-submission-form.jpg',
          url: 'https://forms.gle/RVFrDHbB8WQbFx4A9',
          price: 'free'
        },
        {
          name: this.$t('metadata_changes_form'),
          description: this.$t('metada_changes'),
          category: 'metadata changes',
          provider: 'Indiefy',
          image: '/static/img/forms/metadata-changes.jpg',
          url: 'https://forms.gle/q52ynbs68DdrZAGE8',
          price: 'pro'
        },
        {
          name: this.$t('migration_to_indiefy_form'),
          description: this.$t('migration_to_indiefy'),
          category: 'migration to indiefy',
          provider: 'Indiefy',
          image: '/static/img/forms/migration-indiefy.jpg',
          url: 'https://forms.gle/zZcFqmobKQWnREWN9',
          price: 'free'
        },
        {
          name: this.$t('release_data_confirmation_form'),
          description: this.$t('release_data_confirmation'),
          category: 'release data confirmation',
          provider: 'Indiefy',
          image: '/static/img/forms/release-data-confirmation.jpg',
          url: 'https://forms.gle/1LcvqP69rgHLrw5QA',
          price: 'free'
        },
        {
          name: this.$t('soundcloud_merge_form'),
          description: this.$t('soundcloud_merge'),
          category: 'soundcloud merge',
          provider: 'Indiefy',
          image: '/static/img/forms/soundcloud-merge.jpg',
          url: 'https://forms.gle/RciBG39qmGZGbwtv7',
          price: 'pro'
        },
        {
          name: this.$t('soundcloud_whitelist_form'),
          description: this.$t('soundcloud_whitelist'),
          category: 'soundcloud whitelist',
          provider: 'Indiefy',
          image: '/static/img/forms/soundcloud-whitelist.jpg',
          url: 'https://forms.gle/C97GQwphakAAdCgw7',
          price: 'pro'
        },
        {
          name: this.$t('spotify_content_relocation_form'),
          description: this.$t('spotify_content_relocation'),
          category: 'spotify content relocation',
          provider: 'Indiefy',
          image: '/static/img/forms/spotify-content-relocation.jpg',
          url: 'https://forms.gle/Cazp8WNrRNyC7ggG7',
          price: 'free'
        },
        {
          name: this.$t('takedown_still_live_form'),
          description: this.$t('takedown_still_live'),
          category: 'takedown',
          provider: 'Indiefy',
          image: '/static/img/forms/takedown-still-live.jpg',
          url: 'https://forms.gle/xeJzmydmvLatDzRb8',
          price: 'free'
        },
        {
          name: this.$t('youtube_verification_form'),
          description: this.$t('youtube_verification_official_artist_channel'),
          category: 'youtube verification',
          provider: 'Indiefy',
          image: '/static/img/forms/youtube-verification.jpg',
          url: 'https://forms.gle/NBSiAKbvMPR6yAdcA',
          price: 'pro'
        },
        {
          name: this.$t('youtube_whitelist_form'),
          description: this.$t('youtube_whitelist'),
          category: 'youtube whitelist',
          provider: 'Indiefy',
          image: '/static/img/forms/youtube-whitelist.jpg',
          url: 'https://forms.gle/GN6Gf3hhsh1wKJmv8',
          price: 'pro'
        }
      ]
    }
  },
  computed: {
    filteredServices: function () {
      let services = this.services

      if (this.categoryFilter) {
        services = _.filter(this.services, item => {
          return item.category === this.categoryFilter
        })
      }

      return services
    }
  },
  methods: {
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true

      window.$('html, body').animate({
        scrollTop: 0
      }, 500)

      // eslint-disable-next-line
      // if (!this.user.subscription) {
      //   (window.adsbygoogle = window.adsbygoogle || []).push({})
      // }
    }, 100)
  },
  created: function () {
    this.user = this.$user
    this.stripe = window.Stripe('pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm')

    window.document.title = this.$t('services_title') + ' | Indiefy'
    window.$('meta[name="description"]').attr('content', this.$t('services_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('services_description'))

    if (this.$route.query.beta) {
      this.beta = true
    }
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
.service-description {
  min-height: 90px;
}

.line-through {
  font-size: 12px;
}

.list-group-item {
  display: block !important;
}

.card img {
  border-radius: 3px;
}

.product-price {
  position: absolute;
  bottom: 13px;
  right: 15px;
}

.product-price span {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Forms.vue